<template>
    <v-flex class="form-register-section">
        <div id="wrapper">
            <div class="auth-page register-wrapper">
                <div class="login-panel position-relative">
                    <v-form ref="form" v-model="validate" lazy-validation @submit.prevent="register"
                        class="form-container">
                        <div class="form-group fg-container pt-2">
                            <div class="btn-login-title">
                                <img src="../../../../../public/images/a_page_access_global/login-icons/register_label.png"
                                    style="width: 200px;">
                                <img class="register-member"
                                    src="../../../../../public/images/a_page_access_global/login-icons/register_member.png">
                            </div>
                        </div>
                        <div class="form-group mb-0">
                            <label class="h6 pt-0 pb-0 prime-color font-weight-bold margin-auto">ប្រភេទអ្នកប្រើប្រាស់ |
                                USER
                                TYPE</label>

                            <v-radio-group v-model="selectedUserType" row class="m-0 " :disabled="verifiedUserType()">
                                <v-spacer></v-spacer>
                                <v-radio color="info" value="PLAYER" class="mb-0"> <template v-slot:label>
                                        <strong class="info--text" style="margin-top:6px;">PLAYER</strong>
                                    </template></v-radio>
                                <v-spacer></v-spacer>
                                <v-radio color="orange" value="AFFILIATE">
                                    <template v-slot:label>
                                        <strong class="orange--text" style="margin-top:6px;">AFFILIATE</strong>
                                    </template>
                                </v-radio>
                                <v-spacer></v-spacer>
                            </v-radio-group>
                        </div>
                        <div class="form-group section-input py-0 " style="margin-top:-10px!important;">
                            <div class="form-group">
                                <label class="h6 pt-0 pb-0 prime-color font-weight-bold">ឈ្មោះអ្នកប្រើប្រាស់ |
                                    USERNAME</label>
                                <div class="input-group prime-input" style="">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text prime-bg-color" style="margin-left:-1px;">
                                            <v-icon color="white">mdi-account </v-icon>
                                        </div>
                                    </div>
                                    <input v-model="passUser.user_name" class="form-control" placeholder="Username"
                                        required type="text" @input="error = false">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="h6 pt-0 pb-0 prime-color font-weight-bold">ឈ្មោះពេញ | FULL NAME</label>
                                <div class="input-group prime-input" style="">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text prime-bg-color" style="margin-left:-1px;">
                                            <v-icon color="white">mdi-account </v-icon>
                                        </div>
                                    </div>
                                    <input v-model="passUser.fullname" class="form-control" placeholder="Fullname"
                                        required type="text" @input="error = false">
                                </div>
                            </div>

                            <div class="form-group mb-0">
                                <label class="h6 pt-0 pb-0 prime-color font-weight-bold">អ្នកណែនាំ | INVITE CODE</label>
                                <div class="input-group prime-input" style="">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text prime-bg-color" style="margin-left:-1px;">
                                            <v-icon color="white">mdi-account-multiple </v-icon>
                                        </div>
                                    </div>
                                    <input v-model="registerCode" class="form-control" placeholder="InviteCode"
                                        :disabled="!this.$route.params.register_code ? true : false" type="text"
                                        @input="error = false">
                                </div>
                            </div>
                            <div class="form-group" style="margin-top:-10px;"
                                v-if="!this.$route.query.affcode && !this.$route.query.agcode">
                                <label class="h6 pt-0 pb-0 prime-color font-weight-bold">ប្រភេទលុយ | CURRENCY
                                    TYPE</label>
                                <div class="input-group prime-input" style="">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text prime-bg-color" style="margin-left:-1px;">
                                            <v-icon color="white">mdi-cash </v-icon>
                                        </div>
                                    </div>
                                    <select v-model="passUser.currency_type"
                                        class="form-control register-select-currency">
                                        <option value="1">Dollar $ | ដុល្លា</option>
                                        <option value="2">Riel ៛| លុយខ្មែរ រៀល</option>
                                        <option value="4">đồng ₫ | ដុង</option>
                                        <option value="5">Baht ฿| បាត</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group ">
                                <label class="h6 pt-0 pb-0 prime-color font-weight-bold">លេខសម្ងាត់ | Password</label>
                                <div class="input-group prime-input mb-0" style="">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text prime-bg-color" style="margin-left:-1px;">
                                            <v-icon color="white">mdi-lock </v-icon>
                                        </div>
                                    </div>
                                    <input v-model="passUser.password" class="form-control mb-0" placeholder="Password"
                                        required type="password" @input="error = false">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="h6 pt-0 pb-0 prime-color font-weight-bold">បញ្ជាក់លេខសម្ងាត់ | Confirm
                                    Password</label>
                                <div class="input-group prime-input mb-0" style="">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text prime-bg-color" style="margin-left:-1px;">
                                            <v-icon color="white">mdi-lock </v-icon>
                                        </div>
                                    </div>
                                    <input v-model="passUser.confirm_password" class="form-control mb-0"
                                        placeholder="Confirm Password" required type="password" @input="error = false">
                                </div>
                            </div>
                            <div class="form-group mb-0">
                                <label class="h6 pt-0 pb-0 prime-color font-weight-bold">លេខទូរសព្ទ | Phone</label>
                                <div class="input-group prime-input mb-0" style="">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text prime-bg-color" style="margin-left:-1px;">
                                            <v-icon color="white">mdi-phone-in-talk </v-icon>
                                        </div>
                                    </div>
                                    <input v-model="passUser.phone" class="form-control mb-0" placeholder="Phone Number"
                                        required type="text" @input="error = false">
                                </div>
                            </div>
                            <div class="form-group mb-0 captcha-container justify-center d-flex">
                                <vue-recaptcha ref="recaptcha" @verify="onVerify" @expired="onExpired"
                                    :sitekey="sideKey" class="captcha-class"></vue-recaptcha>

                            </div>
                        </div>

                        <div v-if="error" style="color:#9e000e; text-align:center; padding-bottom: 20px">{{ errorMessage
                            }}</div>
                        <div style="width: 100%;text-align: center; margin-top:120px;">
                            <button v-if="!passLoading" type="submit" class="btn px-5 pt-2 submit-btn">
                                {{ $t('title.register') }}
                            </button>
                            <v-btn v-if="passLoading" :disabled="passLoading" type="submit" color="grey-lighten-3"
                                class="px-5 btn btn-secondary " style="border-radius:5px;">
                                <v-icon>
                                    mdi-refresh mdi-spin
                                </v-icon>
                            </v-btn>
                        </div>


                    </v-form>
                </div>
                <div class="bgLogo">
                    <div class="register-logoImg">
                        <img src="../../../../../public/images/logo_background/logo-login.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </v-flex>
</template>


<script>
import "@/assets/css/login.css";
import { mapGetters, mapMutations } from "vuex";
export default {

    props: ['passUser', 'passValid', 'passLoading', 'passLanguage', 'error',],
    data() {
        return {
            rules: {
                required: [(value) => !!value || 'Required.'],
            },
            checker: true,
            validate: false,
            formLogo: '/images/logo-login.png',
            isShowPassowrd: false,
        }
    },
    computed: {
        ...mapGetters("$_auth", {
            recaptchaToken: "getRecaptchaToken",
        }),
        sideKey() {
            return process.env.VUE_APP_SITE_KEY
        },
        registerCode() {
            // Access the route parameter
            if (this.$route.query.agcode)
                return this.$route.query.agcode;
            else if (this.$route.query.affcode)
                return this.$route.query.affcode;
            else {
                if (this.passUser.currency_type == 1) {
                    return process.env.VUE_APP_REGISTER_CODE_AGENT_D;
                }
                if (this.passUser.currency_type == 2) {
                    return process.env.VUE_APP_REGISTER_CODE_AGENT_R;
                }
                if (this.passUser.currency_type == 4) {
                    return process.env.VUE_APP_REGISTER_CODE_AGENT_VN;
                }
                if (this.passUser.currency_type == 5) {
                    return process.env.VUE_APP_REGISTER_CODE_AGENT_B;
                }
            }
            return ""
        },
        selectedUserType() {
            // Access the route parameter
            if (this.$route.query.agcode)
                return 'AFFILIATE';
            else {
                return 'PLAYER';
            }
        },
    },
    methods: {
        verifiedUserType() {
            if (this.$route.query.agcode && !this.$route.query.affcode) return false;
            else if (this.$route.query.affcode && !this.$route.query.agcode) return true;
            else if (!this.$route.query.agcode && !this.$route.query.affcode) return false;
            else return true;
        },
        onVerify(response) {
            this.UPDATE_CAPTCHA_TOKEN(response);
        },
        onExpired() {
            this.UPDATE_CAPTCHA_TOKEN(null);
            // Handle the expiration of the reCAPTCHA
        },
        resetCapcha() {
            if (window.grecaptcha) {
                // Reset the reCAPTCHA
                window.grecaptcha.reset();
            }
        },
        reset() {
            this.$refs.form.reset();
        },
        async register() {
            if (!this.recaptchaToken) {
                alert('Please complete the reCAPTCHA');
                return;
            }
            this.passUser.recaptcha_token = this.recaptchaToken;
            if (this.registerCode) this.passUser.register_code = this.registerCode;
            this.passUser.register_type = this.selectedUserType;
            if (this.$refs.form.validate()) {
                //console.log(this.passUser)
                this.$emit("register", this.passUser);
            } else {
                this.reset();
            }
        },
        _changeLanguage(language) {
            this.$emit("changeLanguage", language);
        },
        _goToRouter(data) {
            this.$router.push(data);
        },
        ...mapMutations("$_auth", ["UPDATE_CAPTCHA_TOKEN"]),
    }
}
</script>
<style>
.captcha-container {
    position: relative;
}

.captcha-class {
    position: absolute;
    margin-top: 20px;
}

.primary--text {
    color: #000000 !important;
    caret-color: #000000 !important;
}

textarea:focus,
input:focus {
    color: #000000 !important;
}

input,
select,
textarea,
.v-input,
.v-input:focus {
    color: #000000 !important;
}
</style>